import * as React from "react";
import {
  StyleSheet,
  View,
  Text,
  TouchableOpacity,
  Image,
  Dimensions,
  Platform,
} from "react-native";
import { useNavigation } from "@react-navigation/native";
import CustomIcon from "../CustomIcon";
import Colors from "../../utilities/Color.js";
import { useSelector } from "react-redux";
import { Auth } from "aws-amplify";
import { user_logout } from "../../redux/actions/UserActions";
import AdBanner from "../../components/headers/AdBanner";

// this could be removed(Ras) 02/11/2202
// async function LogoutButton({ navigation }) {
//   Auth.signOut().then(() => {
//     user_logout();
//     navigation.navigate("Welcome");
//   });
// }

export default function MenuBar(props) {
  const navigation = useNavigation();
  const MenuLogo = require("../../assets/res/AURA-LOGO-PRIMARY.svg");
  const MenuLogoApp = require("../../assets/res/AURA_LOGO_PRIMARY.png");
  const myMenuItem = props.data;

  const userInvestID = useSelector((state) => state.invest.userInvestmentID);

  var earnedAmount = 0;
  var earnedAmount = Number.parseFloat(earnedAmount);

  const balance = useSelector((state) => state.user.userData.balance);
  const investedAmount = balance !== undefined ? balance.amountInvested : 0;

  const investmentData = useSelector((state) => state.invest.transactionData);
  investmentData.forEach((val) => (earnedAmount += val.amount));
  const win = Dimensions.get("window");
  const hideAdBanner = useSelector((state) => state.uistate.hideAdBanner);
  return (
    <View style={styles.MenuBarBox}>
      {win.width > 1200 && !hideAdBanner && Platform.OS == "web" ? (
        <View style={styles.BannerContainer}>
         {/*  <AdBanner /> */}
        </View>
      ) : null}
      <View style={styles.statusBox}>
        <View style={styles.logoContainer}>
          <TouchableOpacity
            style={styles.iconContainer}
            onPress={() => navigation.popToTop()}
          >
            {Platform.OS !== "web"
              ? <Image style={styles.mainMenuLogoApp} source={MenuLogoApp} />
              : <Image style={styles.mainMenuLogo} source={MenuLogo} />
           }
          </TouchableOpacity>
        </View>
        <View style={styles.menuContainer}>
          <View style={styles.menuRightContainer}>
            <TouchableOpacity
              style={styles.tabContainer}
              onPress={() => navigation.navigate("BuyOnline")}
            >
              <View style={styles.menuWrapper}>
                <View style={styles.iconLabelContainer}>
                  {myMenuItem == 1 ? (
                    <Text style={styles.activeMenuTextStyle}>Buy</Text>
                  ) : (
                    <Text style={styles.menuTextStyle}>Buy</Text>
                  )}
                </View>
              </View>
            </TouchableOpacity>
            <TouchableOpacity
              style={styles.tabContainer}
              onPress={() => navigation.navigate("InvestHome")}
            >
              <View style={styles.menuWrapper}>
                <View style={styles.iconLabelContainer}>
                  {myMenuItem == "4" ? (
                    <Text style={styles.activeMenuTextStyle}>Invest</Text>
                  ) : (
                    <Text style={styles.menuTextStyle}>Invest</Text>
                  )}
                </View>
              </View>
            </TouchableOpacity>
            <TouchableOpacity
              style={styles.tabContainer}
              onPress={() => navigation.navigate("DonateTypeSelectScreen")}
            >
              <View style={styles.menuWrapper}>
                <View style={styles.iconLabelContainer}>
                  {myMenuItem == "5" ? (
                    <Text style={styles.activeMenuTextStyle}>Donate</Text>
                  ) : (
                    <Text style={styles.menuTextStyle}>Donate</Text>
                  )}
                </View>
              </View>
            </TouchableOpacity>
          </View>

          <View style={styles.menuLeftContainer}>
            <View style={styles.topTotalInvetmentContainer}>
              <Text style={styles.topTotalInvetment}>
                {userInvestID === 0
                  ? "$".concat(investedAmount.toFixed(2))
                  : earnedAmount === 0
                  ? " "
                  : "$".concat(
                      earnedAmount
                        .toFixed(2)
                        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                    )}
              </Text>
            </View>
            <View>
              <TouchableOpacity
                style={styles.tabContainer}
                onPress={() => navigation.navigate("Settings")}
              >
                <View style={styles.menuWrapper}>
                  <View style={styles.iconContainer}>
                    <CustomIcon
                      name={"icon-menu-profile"}
                      size={27}
                      color="rgb(78, 189, 239)"
                    />
                  </View>
                </View>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  MenuBarBox: {
    flex: 1,
    // height: 370,
    // backgroundColor: "green",
  },

  BannerContainer: {
    flex: 1,
    zIndex: 100,
    marginBottom: -32,
    maxHeight: 32,
    height: 32,
  },
  statusBox: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: Colors.WHITE,
    marginBottom: 20,
    paddingTop: 20,
    paddingBottom: 30,
    height: 100,
    borderBottomColor: Colors.LIGHTGRAY,
    borderBottomWidth: 1,
  },
  menuRightContainer: {
    flex: 1,
    flexDirection: "row",
    alignItems: "flex-start",
    marginLeft: 90,
    justifyContent: "space-around",
  },
  menuWrapper: {
    alignItems: "center",
    minHeight: 40,
  },
  iconLabelContainer: {
    flexDirection: "row",
    alignItems: "flex-start",
    padding: 10,
  },
  logoContainer: {
    alignItems: "flex-start",
    paddingLeft: 30,
  },
  mainMenuLogo: {
    height: 40.89,
    width: 85,
    marginLeft: 60,
  },
  mainMenuLogoApp: {
    height: 41,
    width: 85,
    marginLeft: 60,
  },
  menuTextStyle: {
    color: Colors.DARKGRAY,
    fontFamily: "montserrat-medium",
    fontSize: 14,
  },
  activeMenuTextStyle: {
    color: Colors.MIDBLUE,
    fontFamily: "montserrat-medium",
    fontSize: 14,
  },
  menuContainer: {
    flex: 1,
    flexDirection: "row",
    alignSelf: "center",
    marginTop: 20,
  },
  menuLeftContainer: {
    flex: 1,
    marginRight: 60,
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  iconContainer: {
    marginRight: 5,
    justifyContent: "center",
  },
  topTotalInvetment: {
    fontFamily: "montserrat-bold",
    fontSize: 14,
    textAlign: "right",
    color: Colors.DARKGRAY,
    marginRight: 10,
  },
});
